import { handleResponseErr } from 'utils/apiHelperUtils'
import { Toastr } from 'components/global/Toastr'
import { PayrunConfigurationType } from 'types/payrunTransactions'
import { Action } from 'types/redux'
import * as actions from './actions'

type InitStateType = {
  payrun_configuration: PayrunConfigurationType<'Basic salary' | 'Full salary'> | null
  loading: boolean
  errMsg: string
}

const initialState: InitStateType = {
  payrun_configuration: null,
  loading: false,
  errMsg: '',
}

export default function reducer(state = initialState, action: Action): InitStateType {
  const { payload } = action
  switch (action.type) {
    case actions.LOAN_FULL_OR_BASIC_LOAD_PENDING: {
      return {
        ...state,
        loading: !state.payrun_configuration?.value,
      }
    }
    case actions.LOAN_FULL_OR_BASIC_LOAD_FULFILLED:
      return {
        ...state,
        payrun_configuration: payload.data.data.payrun_configuration,
        loading: false,
      }

    case actions.LOAN_FULL_OR_BASIC_LOAD_UPDATE_PENDING: {
      return {
        ...state,
        loading: true,
      }
    }

    case actions.LOAN_FULL_OR_BASIC_LOAD_UPDATE_FULFILLED:
      Toastr.success(action.payload.data.message)
      return {
        ...state,
        payrun_configuration: payload.data.data.payrun_configuration,
        loading: false,
      }

    case actions.LOAN_FULL_OR_BASIC_LOAD_UPDATE_REJECTED:
    case actions.LOAN_FULL_OR_BASIC_LOAD_REJECTED: {
      Toastr.error(handleResponseErr(payload))
      return {
        ...state,
        errMsg: handleResponseErr(payload),
        loading: false,
      }
    }

    default:
      return state
  }
}
